import { HttpClient } from "../HttpClient";
/**
 * * Post Youtube Channel Information
 */
export const PostUserSocialMediaPages = async (channelInfo) => {
  try {
    const { data } = await HttpClient.post(`api/UserSocialMediaPages`, {
      ...channelInfo,
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
